<template>
    <div
        class="group-workcenter-card"
        @click="$emit('selectCard', cardInfos)"
    >
        <div class="group-workcenter-card__header">{{ cardInfos.name }}</div>
        <div
            v-if="isGroup"
            class="group-card__body"
        >
            <div class="label">{{ $t("WorkCentersCard") }}</div>
            <div class="value">{{ cardInfos.workcentersQuantity }}</div>
        </div>
        <div
            v-else
            class="workcenter-card__body"
        >
            <div class="code_card">
                <div class="label">{{ $t("ProductionProgress.Code") }}</div>
                <div class="value">{{ cardInfos.code }}</div>
            </div>
            <div class="resources_card">
                <div class="label">{{ $t("WorkcenterList.Resources") }}</div>
                <div class="value">{{ cardInfos.resourceCount }}</div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        props: {
            isGroup: {
                type: Boolean,
                default: false
            },
            cardInfos: {
                type: Object,
                default: () => ({
                    name: "",
                    workcentersQuantity: 0,
                    code: "",
                    resources: 0
                })
            }
        }
    };
</script>

<style lang="scss">
    .group-workcenter-card {
        border: 1px solid #d8ccc2;
        border-radius: 16px;
        padding: 16px 0;
        text-align: center;
        background-color: #fff;
        cursor: pointer;
        box-shadow: 0 1px 3px rgba(0, 0, 0, 0.05);
        transition: transform 0.2s ease;

        &:hover {
            background-color: #ffede2;
            border-color: #974900;

            .group-workcenter-card__header {
                border-bottom: 1px solid #974900;
            }
        }

        &:active {
            background-color: #ffdbc4;
            border-color: #974900;

            .group-workcenter-card__header {
                border-bottom: 1px solid #974900;
            }
        }

        .group-workcenter-card__header {
            color: #4c4541;
            border-bottom: 1px solid #d8ccc2;
            padding: 0 16px 15px;
            text-align: center;
            font-size: 22px;
            font-weight: 600;
            line-height: 30px;
        }

        .group-card__body,
        .workcenter-card__body {
            padding: 15px 16px 0;
            .label {
                color: #998f8a;
                text-align: center;
                font-size: 16px;
                font-weight: 400;
                line-height: 22px;
            }

            .value {
                color: #4c4541;
                text-align: center;
                font-size: 16px;
                font-weight: 600;
                line-height: 26px;
            }
        }

        .workcenter-card__body {
            display: flex;
            gap: 16px;

            .resources_card,
            .code_card {
                width: 100%;
            }
        }
    }

    @media (max-width: 480px) {
        .group-workcenter-card {
            padding: 12px 0;
            border-radius: 24px;

            .group-workcenter-card__header {
                padding: 0 12px 12px;
                text-align: center;
                font-size: 16px;
                line-height: 26px;
            }

            .group-card__body {
                display: flex;
                justify-content: space-between;
                padding: 12px 12px 0;
                .label {
                    font-size: 12px;
                    line-height: 16px;
                }

                .value {
                    font-size: 14px;
                    line-height: 20px;
                }
            }

            .workcenter-card__body {
                flex-direction: column;
                padding: 12px 12px 0;
                .label {
                    font-size: 12px;
                    line-height: 16px;
                }

                .value {
                    font-size: 14px;
                    line-height: 20px;
                }

                .resources_card,
                .code_card {
                    display: flex;
                    justify-content: space-between;
                    width: 100%;
                }
            }
        }
    }
</style>
